import { render, staticRenderFns } from "./SmallArticleCard.vue?vue&type=template&id=6447471e&scoped=true&"
import script from "./SmallArticleCard.vue?vue&type=script&lang=js&"
export * from "./SmallArticleCard.vue?vue&type=script&lang=js&"
import style0 from "./SmallArticleCard.vue?vue&type=style&index=0&id=6447471e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6447471e",
  null
  
)

export default component.exports